import ContactList from "../Contacts/ContactList";
import {ContactType} from "../Contacts/Enums/ContactType";

export default class FormVerifierAndMarker {
    private formEl: JQuery;
    private formTabs: JQuery;
    private readonly contactList: ContactList;

    constructor(
        formEl: JQuery,
        formTabs: JQuery,
        contactList: ContactList,
    ) {
        this.formEl = formEl;
        this.formTabs = formTabs;
        this.contactList = contactList;

    }

    public attachTabSwitchEvents(validationCallback?: (lastActiveTab: JQuery) => boolean): void {
        this.formTabs.on("hide.bs.tab", (event) => {
            const lastActiveTabJq = jq(event.target);

            if (validationCallback !== undefined) {
                this.markTab(lastActiveTabJq, validationCallback(jq(lastActiveTabJq.attr("data-bs-target"))));
            } else {
                this.validateTab(lastActiveTabJq);
            }

            const activeTabJq = jq(event.relatedTarget);
            const activeTabContent = jq(activeTabJq.attr("data-bs-target"));
            this.formEl.find("#active-fragment").val(activeTabContent.attr("id"));
        });
    }

    public markAllTabs(): void {
        this.formTabs.each((index, element) => {
            this.validateTab(jq(element));
        });
    }

    public validateTab(tabJq: JQuery): void {
        const lastActiveTabContent = jq(tabJq.attr("data-bs-target"));

        const isFragmentValid = this.validateFormFragment(lastActiveTabContent);
        this.markTab(tabJq, isFragmentValid);
    }

    public markTab(selectedTabJq: JQuery, isFragmentValid: boolean): void {
        const iconClass = "fragment-state-icon";
        const successClasses = ["fa-check-circle", "text-success"];
        const errorClasses = ["fa-times", "text-danger"];
        const validTabClass = "valid-tab";
        const invalidTabClass = "invalid-tab";

        selectedTabJq.find(`.${iconClass}`).remove();
        selectedTabJq.removeClass(validTabClass);
        selectedTabJq.removeClass(invalidTabClass);

        const iconClasses = [iconClass, "fas", "fa-lg", "fa-fw"];
        let tabClass: string;
        if (isFragmentValid) {
            iconClasses.push(...successClasses);
            tabClass = "valid-tab";
        } else {
            iconClasses.push(...errorClasses);
            tabClass = "invalid-tab";
        }

        const tabIcon = document.createElement("i");
        tabIcon.classList.add(...iconClasses);

        selectedTabJq.append(tabIcon);
        selectedTabJq.addClass(tabClass);
    }

    public validateFormFragment(fragmentContainer: JQuery): boolean {
        if (fragmentContainer.hasClass("ignored")) {
            return true;
        }
        let fragmentInputs = fragmentContainer.find("input:not(.ignore-validation, .original-data-input), select:not(.ignore-validation)").filter((index, element) => {
            return jq(element).parents(".original-value-container").length === 0; // Filter away inputs containing original value - no need to validate
        });
        if (fragmentContainer.is("#represented-persons")) {
            fragmentInputs = fragmentInputs.filter((index, element) => {
                return jq(element).parents(".add-person-card").length === 0 &&
                    jq(element).parents(".edit-form-container").length === 0;
            });
        }

        const isFormValid = fragmentInputs.length > 0 ? fragmentInputs.valid() : true;

        if (fragmentContainer.is("#contacts")) {
            if (this.contactList) {
                const validEmails = this.contactList.validateContactType(ContactType.Email);
                const validPhones = this.contactList.validateContactType(ContactType.PhoneNumber);

                return isFormValid && validEmails && validPhones;
            }
        }

        return isFormValid;
    }

    public getFormValidationIgnoreSelector(form: JQuery): string {
        return form.data("validator").settings.ignore;
    }

    public setFormValidationIgnoreSelector(form: JQuery, ignoreSelector: string): void {
        form.data("validator").settings.ignore = ignoreSelector;
    }

    public setInputRequiredMessage(form: JQuery, inputName: string, message: string): void {
        const settings = form.data("validator").settings;
        jq.extend(true, settings, {
            messages: {
                [inputName]: {
                    required: message,
                },
            },
        });
    }

    public setInputIsRequired(form: JQuery, inputName: string, required: boolean): void {
        const settings = form.data("validator").settings;
        jq.extend(true, settings, {
            rules: {
                [inputName]: {required},
            },
        });
    }

    public ignoreOnlyDoctorHiddenFields(form: JQuery): void {
        const ignoreFieldsSelector = ".doctor-input.input-hidden";
        this.setFormValidationIgnoreSelector(form, ignoreFieldsSelector);
    }

    public ignoreNoFields(form: JQuery): void {
        const ignoreFieldsSelector = "";
        this.setFormValidationIgnoreSelector(form, ignoreFieldsSelector);
    }
}
